import script from "./ButtonBase.vue?vue&type=script&lang=ts&setup=true"
export * from "./ButtonBase.vue?vue&type=script&lang=ts&setup=true"

import "./ButtonBase.vue?vue&type=style&index=0&id=a7e1e476&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a7e1e476"]])

export default __exports__